import React from 'react';
import './AdministrationHome.css';
import StatsDashboard from '../dashboard/StatsDashboard';

function AdministrationHome() {
  return (
    <div className="administration-home">
      {/* System Statistics Dashboard */}
      <StatsDashboard />
    </div>
  );
}

export default AdministrationHome; 